import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Manifesto from "@/pages/Manifesto";
import Product from "@/pages/Product";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Support from "@/pages/Support";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Gdpr from "@/pages/Gdpr";
import Press from "@/pages/Press";
import Careers from "@/pages/Careers";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/manifesto" element={<Manifesto />} />
                    <Route path="/product" element={<Product />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/support" element={<Support />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/cookies" element={<Cookies />} />
                    <Route path="/gdpr" element={<Gdpr />} />
                    <Route path="/press" element={<Press />} />
                    {/* <Route path="/careers" element={<Careers />} /> */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#1a0f24",
                        border: "1px solid rgba(255,90,95,0.3)",
                        color: "#f7ece1",
                    },
                }}
            />
        </div>
    );
}

export default App;
